import { render, staticRenderFns } from "./provinceSelector.vue?vue&type=template&id=4c96144e&scoped=true"
import script from "./provinceSelector.vue?vue&type=script&lang=js"
export * from "./provinceSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c96144e",
  null
  
)

export default component.exports